import { useMutation, useQueryClient } from '@tanstack/react-query';
import { oidcProviderQueryKeys, OIDCProviders } from '#api';

export function useDeleteIdentityProviderMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (oidcProviderID: string) => OIDCProviders.deleteOIDCProvider(oidcProviderID),
    onSuccess: (data, oidcProviderID) => {
      queryClient.removeQueries({ queryKey: oidcProviderQueryKeys.detail(oidcProviderID), exact: true });
      void queryClient.invalidateQueries({ queryKey: oidcProviderQueryKeys.lists() });
    },
  });
}
